import(/* webpackMode: "eager" */ "/vercel/path0/app/(main)/our-work/case-studies/page.tsx");
